import { motion } from "framer-motion";
import { useState } from "react";
import { SERVICES } from "../lib/api";

const IMAGES = {
  limpieza: "https://images.unsplash.com/photo-1719887774987-e66651f442d7",
  blanqueamiento: "https://images.pexels.com/photos/12474261/pexels-photo-12474261.jpeg",
  fluor: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/faf13nyl_flourizacion.jpeg",
  revision: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/oy4ifqw7_Revision-dental-al-dentista-ELECCION-PROFESIONAL-2.jpg",
  ninos: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/hzi1834a_Shutterstock_40544920.jpg",
  mayores: "https://customer-assets.emergentagent.com/job_inhoa-at-home/artifacts/yrvkjm7i_images.jpg",
};

export default function Services() {
  const [active, setActive] = useState(SERVICES[0].key);
  const current = SERVICES.find((s) => s.key === active) || SERVICES[0];

  return (
    <section id="servicios" data-testid="services-section" className="py-24 md:py-40 bg-[color:var(--bg-secondary)]/60">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-6 md:gap-8 mb-16"
        >
          <div className="col-span-12 md:col-span-4 text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)]">
            Servicios
          </div>
          <h2 className="col-span-12 md:col-span-8 font-heading text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
            Un catálogo <em className="italic text-[color:var(--accent)]">breve</em>, pensado para tu bienestar.
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <ul className="col-span-12 md:col-span-7 divide-y divide-[color:var(--border-subtle)] border-y border-[color:var(--border-subtle)]">
            {SERVICES.map((s, idx) => (
              <li
                key={s.key}
                onMouseEnter={() => setActive(s.key)}
                data-testid={`service-item-${s.key}`}
                className={`group flex items-center justify-between py-6 md:py-8 cursor-pointer transition-colors ${active === s.key ? "text-[color:var(--text-primary)]" : "text-[color:var(--text-secondary)]"}`}
              >
                <div className="flex items-baseline gap-6 md:gap-10">
                  <span className="font-mono text-xs opacity-60">{String(idx + 1).padStart(2, "0")}</span>
                  <span className="font-heading text-3xl md:text-5xl tracking-tight leading-none">{s.label}</span>
                </div>
                <span className={`text-2xl transition-transform ${active === s.key ? "translate-x-0 text-[color:var(--accent)]" : "-translate-x-2 opacity-40"}`}>→</span>
              </li>
            ))}
          </ul>

          <motion.div
            key={active}
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-5 md:sticky md:top-24 h-fit"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-[color:var(--bg-secondary)]" data-testid="service-preview-image">
              <img src={IMAGES[active]} alt={current.label} className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-[color:var(--signature-dark)]/15" />
            </div>
            <p className="mt-6 text-[color:var(--text-secondary)] leading-relaxed">{current.desc}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
